/**
 * apply a function for each property in an object
 * also traverse arrays if they contain objects
 */
export function nestedForEach(
  data: unknown,
  apply: (keys: (string | number)[], value: unknown) => void,
  parentKeys: (string | number)[] = [],
) {
  if (Array.isArray(data) && typeof data[0] === 'object' && data[0] !== null) {
    data.forEach((value, index) => {
      nestedForEach(value, apply, [...parentKeys, index]);
    });
  } else if (
    typeof data === 'object' &&
    data !== null &&
    !Array.isArray(data) &&
    // ignore File objects
    !(data instanceof File)
  ) {
    Object.entries(data).forEach(([key, value]) => {
      nestedForEach(value, apply, [...parentKeys, key]);
    });
  } else {
    apply(parentKeys, data);
  }
}
